export default "__VITE_ASSET__Xk$jxJjh__"